import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment'
import AddButton from '../partials/AddButton';
import { Grid, Space } from '@mantine/core';
import { Box, ActionIcon,Affix, Center, Paper, Overlay} from '@mantine/core';
import { IconSquareRoundedX } from '@tabler/icons';
import _ from 'lodash';
import { Button} from '@mantine/core';


import ContainerTranslation from "../partials/ContainerTranslation";

import { fetchEightD, updateFieldEightD, addFieldEightD,removeFieldEightD, validate } from '../../actions/eightD';

import history from '../../history';
import { InputText } from '../input/InputText.tsx';
import { InputDate } from '../input/InputDate';
import { TextAreaLabeled } from '../input/TextAreaLabeled';
import { SelectLabeled } from '../input/SelectLabeled.tsx';
import FormStepper from './FormStepper';


var updateTimeout = {}




class FormContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isPopupOpen: false
    }
    this.props.fetchEightD(this.props.match.params.id);
  } 


  togglePopup() {
    if (this.state.isPopupOpen) {
      this.setState({ isPopupOpen: false })
    }
    else {
      this.setState({ isPopupOpen: true })
    }
  }


  scrollTop() {
    window.scrollTo(0, 0);
  }


  handleStepperClick(step) {
    const _this = this
    _this.refs[step].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


  componentDidUpdate(prevProps) {
    if (this.props.message === 'EightD has been validated') {
      history.push('/8D/' + this.props.eightD._id);
    }

  }


  handleInputChange(obj, isValid, withTimeout) {
    
    let _this = this
    if (withTimeout) {
      clearTimeout(updateTimeout[obj.name]);
      updateTimeout[obj.name] = setTimeout(function () {
        delete updateTimeout[obj.name]
        _this.props.updateFieldEightD(obj, _this.props.match.params.id);
      }, 10000)
    } else {
      _this.props.updateFieldEightD(obj, _this.props.match.params.id);
    }

    }

    handleFieldOnChangeFactory(parent,subfield) {
        const handleFieldOnChange = (e) => {
            this.props.updateFieldEightD({
                name: subfield,
                value: e.value,
                parent: parent,
            }, this.props.match.params.id);
        }
        return handleFieldOnChange.bind(this)
    }


  handleBlurFactory(parent,index){
    const handleBlur = (e) => {
      this.props.updateFieldEightD({name : e.target.name, value : e.target.value, parent : parent,  index : index}, this.props.match.params.id);
    }
    return handleBlur
  }



  handleDateChangeFactory(name,parent,index){
    const _this = this
    function handleChangeDate(date){

      if (date === null || date === undefined){
        return _this.props.updateFieldEightD({name:name,parent:parent,index:index,value:null}, _this.props.match.params.id);
      }
      const parseddate = new Date(date) 
      const formattedDate = parseddate !== "Invalid Date" ? moment(parseddate).format('DD/MM/YYYY') : null

      return _this.props.updateFieldEightD({name:name,parent:parent,index:index,value:formattedDate}, _this.props.match.params.id);
    }
    return handleChangeDate
  }

  string2Date(date){
    return date ? new Date(Date.parse(moment(date, 'DD/MM/YYYY').toISOString())) : null
  }


  handleDocumentValidation(obj){
    let _this = this;
    _this.props.validate(obj,_this.props.eightD._id);
  }

  renderValidate() {
    if(!localStorage.user || !this.props.eightD.authorization.validate){
      return null;
    }

    if(this.props.eightD.progression.globalPercentage !== 100){
      return(
        <div>
          <Button data-disabled onClick={(event) => event.preventDefault()}>
            {this.props.translate("content.information.document-validation-status.contexte")}
          </Button>
        </div>
      )
    }

    if(this.props.eightD.progression.globalPercentage === 100 && this.state.isPopupOpen === false){
      return(
        <div className="btn-dashboard"> 
          <button style={{ width: "200px" }} className="primary-btn"   onClick={ () => {this.togglePopup()} } >   
            Valider le document    
          </button>      
        </div>
      )
    }

    if(this.props.eightD.progression.globalPercentage === 100 && this.state.isPopupOpen){
      return(
        <div>
          <>
            <Overlay color="#000" backgroundOpacity={0.85} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} />
          </>
          <Affix position={{ bottom: (window.innerHeight)/2, left: (window.innerWidth -258.28)/2 }}>
          <div style={{position:"absolute", top:-18,right:-18}}>
              <ActionIcon variant="filled" radius="xl" size="xl" color="red">
              <IconSquareRoundedX onClick={ () => this.togglePopup()} style={{ width: '70%', height: '70%' }} />
              </ActionIcon>
          </div>
          <Box >
            <Paper shadow="md" radius="xl" p="xl">
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <ContainerTranslation id={"nav." + ['Validate context']}/>
              </div>
              <Space h="xs" />
              <Center>
                <div className="btn-dashboard"> 
                  <button style={{ width: "200px" }} className="primary-btn"  onClick={() => { this.handleDocumentValidation(); this.props.history.goBack(); }} >   
                    Valider le document    
                  </button>      
                </div>
              </Center>
            </Paper>
          </Box>
          </Affix>
        </div>
      )
    }
  }


  renderInputTextInformation(field,title){
    return (              
      <div className={"formulaire-field text"}>
      <InputText
        onBlur={this.handleBlurFactory('information')}
        value={this.props.eightD.content['information'][field]}
        name={field}
        isRequired={true}
        label={{title : title}}
      />
    </div>)
  }


  renderInputProblemDescription(field,title){
    return (              
      <div className={"formulaire-field text"}>
      <InputText
        onBlur={this.handleBlurFactory('problem-description.description')}
        value={this.props.eightD.content['problem-description']['description'][field]}
        name={field}
        isRequired={false}
        label={{title : title}}
      />
    </div>)
  }

  renderInputTextAreaProblemDescription(field,title){

    const _this = this;

    return (              
      <div className={"formulaire-field text"}>
      <p>{title}</p>
      <div >
        <TextAreaLabeled
          onBlur={_this.handleBlurFactory('problem-description.description')}
          name={field}
          value={_this.props.eightD.content['problem-description']["description"][field]}
          isRequired={true}
          label={{title :field}}
          placeholder={""}
          maxLength={500}
          height={'100px'}
        />
      </div>
    </div>)
  }


  createNewTeamEntry(path){
    const objToReturn = {'name':'','role':''}
    this.props.addFieldEightD(objToReturn, "content." +path, this.props.match.params.id);
  }

  createNewActionEntry(path){
    const objToReturn =  {"action":"", "author":"", "closure-date":"", "DDC":""}
    this.props.addFieldEightD(objToReturn, "content." +path, this.props.match.params.id);
  }

  createNewCauseEntry(path){
    const objToReturn = {'cause':''}
    this.props.addFieldEightD(objToReturn, "content." +path, this.props.match.params.id);
  }

  removeField(i, path) {
    this.props.removeFieldEightD(i, path, this.props.match.params.id);
  }


  renderTeam(team,path) {
    let contents = []
    let _this = this

    _.each(team, function (member, i) {
      let keySuffix = i + Date.now()
      keySuffix = keySuffix.toString()
      if (i >= 0) {
          contents.push(<div key={'separator-' + keySuffix} className="separator">
              <div className="delete-part"
                  onClick={_this.removeField.bind(_this, i, "content." + path)}
                  key={'team-remove-' + keySuffix}
                  id={'team-remove-' + keySuffix}>
                  <i className="fas fa-trash"
                      style={{ color: '#ffffff' }}>
                  </i>
              </div>
          </div>)
      }

      contents.push(<div key={'tool0-name-' +keySuffix}>
                      <div key={'tool1-name-' +keySuffix} className={"inline"} style={{ width: 'calc(50% - 15px)' }}>
                      <InputText
                        onBlur={_this.handleBlurFactory(path,i)}
                        value={member.name}
                        name={'name'}
                        isRequired={true}
                        label={{title : 'name'}}
                      />
                      </div>
                      <div key={'tool1-role-' + keySuffix} className={"inline"} style={{ width: 'calc(50% - 15px)' }}>
                      <InputText
                        onBlur={_this.handleBlurFactory(path,i)}
                        value={member.role}
                        name={'role'}
                        isRequired={true}
                        label={{title : 'role'}}
                      />
                      </div>
                    </div>)

    })
    contents.push(<div key={'team-duplicate'} onClick={_this.createNewTeamEntry.bind(_this,path)} className="duplicate" >
      <AddButton />
    </div>)
    return (
      <div className={"formulaire wide"}>
        <div className={"formulaire-field text"}>
          {contents}
        </div>
      </div>
    )
  }

  renderCause(causes) {
    let contents = []
    const path = "root-cause-analysis.causes"
    let _this = this

    _.each(causes, function (cause, i) {
      const keySuffix = i + Date.now()
      if (i >= 0) {
          contents.push(<div key={'separator-' + keySuffix} className="separator">
              <div className="delete-part"
                  onClick={_this.removeField.bind(_this, i, "content." + path)}
                  key={'cause-remove-' + path + keySuffix}
                  id={'cause-remove-' + path + keySuffix}>
                  <i className="fas fa-trash"
                      style={{ color: '#ffffff' }}>
                  </i>
              </div>
          </div>)
        contents.push()
      }


      contents.push(<div key={'cause0-' + keySuffix}>
                      <div key={'cause1-' + keySuffix} className={"inline"} style={{ width: 'calc(50% - 15px)' }}>
            
                        <div className={"formulaire-field textarea"}>
                          <TextAreaLabeled
                            onBlur={_this.handleBlurFactory(path,i)}
                            name={"cause"}
                            value={cause.cause}
                            isRequired={true}
                            label={{title :"cause"}}
                            placeholder={"Pourquoi?"}
                            maxLength={1000}
                            height={'100px'}
                          />
                      </div>
                    </div>
                  </div>)

    })

    contents.push(<div key={'team-duplicate'} onClick={_this.createNewCauseEntry.bind(_this,path)} className="duplicate" >
      <AddButton />
    </div>)

    return (
      <div className={"formulaire wide"}>
        <div className={"formulaire-field text"}>
          {contents}
        </div>
      </div>
    )

  }


  renderAction(actions,path) {
    let contents = []
    let _this = this

    _.each(actions, function (action, i) {
      let keySuffix = i + Date.now()
      if (i >= 0) {
          contents.push(<div key={'separator-' + keySuffix} className="separator">
              <div className="delete-part"
                  onClick={_this.removeField.bind(_this, i, "content." + path)}
                  key={'action-remove-' + path + keySuffix}
                  id={'action-remove-' + path + keySuffix}>
                  <i className="fas fa-trash"
                      style={{ color: '#ffffff' }}>
                  </i>
              </div>
          </div>)
        contents.push()
      }

      contents.push(<div key={'action0-author-' +  keySuffix}>
                      <div key={'action1-author-' +  keySuffix}  style={{ width: 'calc(50% - 15px)' }}>
                      <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                        Personne en charge
                      </p>
                      <Space h="xs" />
                      <InputText
                        onBlur={_this.handleBlurFactory(path,i)}
                        value={action.author}
                        name={'author'}
                        isRequired={true}
                        label={{title : 'author'}}
                      />
                      </div>
                      <div key={'action1-closure-date-' + keySuffix} className={"inline"} style={{ width: 'calc(50% - 15px)' }}>
                      <Space h="lg" />
                      <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                        Date de cloture attendue
                      </p>
                      <Space h="xs" />
                      <InputDate
                        locale={_this.props.translate('content.localisation')}
                        onChange={_this.handleDateChangeFactory('closure-date',path,i)}
                        value={_this.string2Date(action['closure-date'])}
                        isRequired={false}
                      />
                      </div>
                      <div key={'action1-DDC' + keySuffix} className={"inline"} style={{ width: 'calc(50% - 15px)' }}>
                      <Space h="lg" />
                      <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                        DDC
                      </p>
                      <Space h="xs" />
                      <InputDate
                        locale={_this.props.translate('content.localisation')}
                        onChange={_this.handleDateChangeFactory('DDC',path,i)}
                        value={_this.string2Date(action['DDC'])}
                        isRequired={false}
                      />
                      </div>
                      <div key={'action1-action-' + keySuffix} style={{ width: 'calc(50% - 15px)' }}>
                      <Space h="lg" />
                      <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                        Action
                      </p>
                      <Space h="xs" />
                      <TextAreaLabeled
                            onBlur={_this.handleBlurFactory(path,i)}
                            name={"action"}
                            value={action.action}
                            isRequired={true}
                            label={{title :"action"}}
                            placeholder={""}
                            maxLength={1000}
                            height={'100px'}
                      />
                      </div>
                    </div>)

    })

    contents.push(<div key={'team-duplicate'} onClick={_this.createNewActionEntry.bind(_this,path)} className="duplicate" >
      <AddButton />
    </div>)

    return (
      <div className={"formulaire wide"}>
        <div className={"formulaire-field text"}>
          {contents}
        </div>
      </div>
    )

  }



  render() {

    var route = "/8D/" + this.props.match.params.id

    var name = "8D"

    if (this.props.eightD && Object.keys(this.props.eightD).length === 0) {
      return (
        <h3>Loading...</h3>
      )
    } else {


      return (

        

        <div className="formulaires">
          <div style={{
            top: 99,
            position: "sticky",
            padding: 20,
            zIndex: 99,
            backgroundColor: "white",
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            border: "solid 1px #E2E3E3"
          }}>
            <FormStepper translate={this.props.translate} progression={this.props.eightD.progression.globalPercentage} categoryProgression={this.props.eightD.progression.completionPerCategory} onClick={this.handleStepperClick.bind(this)}></FormStepper>
          </div>

          <div style={{color:"red"}}>*Fonctionnalité en cours de développement</div>
          <div className="formulaires-header">
            <h2>{name}</h2>
            {/*<p style={{ margin: 0, textAlign: 'center' }}>{"sous-titre"}</p>*/}
            <span className="link-back"><Link to={route}><i className="fas fa-arrow-left" style={{ color: "#E30119", marginRight: "10px" }}></i><ContainerTranslation id={"nav.Back"} /></Link></span>
          </div>


          {/*NEW FORM*/}

          {/*INFORMATIONS*/}
          <div className="formulaire-section">

            <div className="formulaire-header" ref={"information"}>
              <h2>General information </h2>
            </div>
            {this.renderInputTextInformation('title', "Titre du problème") }
            {this.renderInputTextInformation('source',"Source") }



            <Grid columns={13} >
              <Grid.Col span={5} style={{ maxHeight: (60) }}>
                <br></br>
                <p>Date d'identification du problème</p>
              </Grid.Col>
              <Grid.Col span={5} style={{ maxHeight: (60) }} >
                <br></br>
                <p>Date d'initiation du rapport</p>
              </Grid.Col>
              <Grid.Col span={3} style={{ maxHeight: (60) }} >
                <p>Est-ce que le client est notifié?</p>
              </Grid.Col>
            </Grid>

            <Grid columns={13}>
              <Grid.Col span={5}>
                <div className={"formulaire-field text"}  >
                  <div className={"inline"}>
                    <InputDate
                      locale={this.props.translate('content.localisation')}
                      onChange={this.handleDateChangeFactory('problem-detection-date','information',null)}
                      value={this.string2Date(this.props.eightD.content['information']['problem-detection-date'])}
                      isRequired={false}
                    />
                  </div>
                </div>
                </Grid.Col>
                <Grid.Col span={5}>
                  <div className={"formulaire-field text"}  >
                    <InputDate
                      locale={this.props.translate('content.localisation')}
                      onChange={this.handleDateChangeFactory('creation-date','information',null)}
                      value={this.string2Date(this.props.eightD.content['information']['creation-date'])}
                      isRequired={false}
                    />
                  </div>
                </Grid.Col>
                <Grid.Col span={3}>
                  <br></br>
                          <div style={{ width: "160px" }}>
                              <SelectLabeled
                                  label={{ title: this.props.translate(`content.information.is-client-informed?.title`) }}
                                  value={{ value: this.props.eightD.content['information']['is-client-informed?'], label: this.props.eightD.content['information']['is-client-informed?'] }}
                                  onChange={this.handleFieldOnChangeFactory('information','is-client-informed?')}
                                  options={["Oui", "Non"].map((x) => { return {value : x, label:x} })}
                              />
                  </div>
                </Grid.Col>
              </Grid>
          </div>


          <div className="formulaire-section">

            <div className="formulaire-header" ref={"team.members"}>
              <h2>D1 - Équipe </h2>
              <div className={"inline"} style={{ float:"right",display:'inline-block' }}>
                  <div className={"formulaire-field text"}  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p >
                        DDC
                      </p>
                      <div style={{ margin: "0px", marginLeft: "20px" }} >
                        <InputDate
                          locale={this.props.translate('content.localisation')}
                          onChange={this.handleDateChangeFactory('date','team',null)}
                          value={this.string2Date(this.props.eightD.content.team['date'])}
                          isRequired={false}
                        />
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <h3 style={{ display:'inline-block',marginLeft: '150px',bottom:"0px",position:"relative",top:"30px" }}>Name</h3><h3 style={{ display:'inline-block' , float:"right",marginRight: '200px',position:"relative",top:"30px"}}>Role</h3>
              {this.renderTeam(this.props.eightD.content.team.members,'team.members') }
          </div>

          <div className="formulaire-section">

            <div className="formulaire-header" ref={"problem-description.description"}>
              <h2>D2 - Description du problème </h2>
              <div className={"inline"} style={{ float:"right",display:'inline-block' }}>
              <div className={"formulaire-field text"}  >
              <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ display:'inline-block' }}>
                    DDC
                  </p>
                  <div  style={{ display:'inline-block' ,marginLeft: '20px' }}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('date','problem-description',null)}
                    value={this.string2Date(this.props.eightD.content['problem-description']['date'])}
                    isRequired={false}
                  />
                  </div>
                  </div>
                </div>
              </div>
            </div>
            {this.renderInputTextAreaProblemDescription('what', "Quoi") }
            {this.renderInputProblemDescription('who', "Qui") }
            {this.renderInputProblemDescription('where', "Où") }
            {this.renderInputProblemDescription('when', "Quand") }
            {this.renderInputTextAreaProblemDescription('why', "Pourquoi") }
            {this.renderInputProblemDescription('how-much', "Combien") }

          </div>

          <div className="formulaire-section">
            <div className="formulaire-header" ref={"immediate-actions.actions"}>
              <h2>D3 - Actions immédiates: Correction / confinement </h2>
              <div className={"inline"} style={{ float:"right",display:'inline-block' }}>
              <div className={"formulaire-field text"}  >
              <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ display:'inline-block' }}>DDC</p>
                  <div  style={{ display:'inline-block' ,marginLeft: '20px' }}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('date','immediate-actions',null)}
                    value={this.string2Date(this.props.eightD.content['immediate-actions']['date'])}
                    isRequired={false}
                  />
                  </div>
                  </div>
                  </div>
              </div>
            </div>
            {this.renderAction(this.props.eightD.content["immediate-actions"].actions,"immediate-actions.actions") }
          </div>

          <div className="formulaire-section">
            <div className="formulaire-header" ref={"root-cause-analysis.causes"}>
              <h2>D4 - Analyse des causes </h2>
              <div className={"inline"} style={{ float:"right",display:'inline-block' }}>
                <div className={"formulaire-field text"}  >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ display:'inline-block' }}>DDC</p>
                  <div  style={{ display:'inline-block' ,marginLeft: '20px' }}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('date','root-cause-analysis',null)}
                    value={this.string2Date(this.props.eightD.content["root-cause-analysis"]['date'])}
                    isRequired={false}
                  />
                  </div>
                  </div>
                  </div>
              </div>
            </div>
            {this.renderCause(this.props.eightD.content["root-cause-analysis"].causes,"root-cause-analysis.causes") }
          </div>


          <div className="formulaire-section">
            <div className="formulaire-header" ref={"corrective-action.actions"}>
              <h2>D5 & D6 - Actions correctives (Éliminitation des causes) </h2>
              <div className={"inline"} style={{ float:"right",display:'inline-block' }}>
                <div className={"formulaire-field text"}  >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ display:'inline-block' }}>DDC</p>
                  <div  style={{ display:'inline-block' ,marginLeft: '20px' }}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('date','corrective-action',null)}
                    value={this.string2Date(this.props.eightD.content["corrective-action"]['date'])}
                    isRequired={false}
                  />
                  </div>
                  </div>
                  </div>
              </div>
            </div>
            {this.renderAction(this.props.eightD.content["corrective-action"].actions,"corrective-action.actions") }
          </div>


          <div className="formulaire-section">
            <div className="formulaire-header" ref={"preventive-action.actions"}>
              <h2>D7 - Prévention de la recurrence </h2>
              <div className={"inline"} style={{ float:"right",display:'inline-block' }}>
                <div className={"formulaire-field text"}  >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ display:'inline-block' }}>DDC</p>
                  <div  style={{ display:'inline-block' ,marginLeft: '20px' }}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('date','preventive-action',null)}
                    value={this.string2Date(this.props.eightD.content["preventive-action"]['date'])}
                    isRequired={false}
                  />
                  </div>
                  </div>
                  </div>
              </div>
            </div>
            {this.renderAction(this.props.eightD.content["preventive-action"].actions,"preventive-action.actions") }
          </div>

          <div className="formulaire-section">
            <div className="formulaire-header" ref={"conclusion.actions"}>
              <h2>D8 - Clôture / Remerciements </h2>
              <div className={"inline"} style={{ float:"right",display:'inline-block' }}>
                <div className={"formulaire-field text"}  >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ display:'inline-block' }}>DDC</p>
                  <div  style={{ display:'inline-block' ,marginLeft: '20px' }}>
                  <InputDate
                    locale={this.props.translate('content.localisation')}
                    onChange={this.handleDateChangeFactory('date','conclusion',null)}
                    value={this.string2Date(this.props.eightD.content["conclusion"]['date'])}
                    isRequired={false}
                  />
                  </div>
                  </div>
                  </div>
              </div>
            </div>
            {this.renderAction(this.props.eightD.content["conclusion"].actions,"conclusion.actions") }
          </div>


          <div className="btn-dashboard">
            <p>
              {this.props.eightD.progression ? this.props.eightD.progression.globalPercentage : 0}<ContainerTranslation id={"nav." + ['completed']} />
            </p>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Link to={route}>
                <button className="primary-btn" style={{ width: "200px" }}>
                  <ContainerTranslation id={"nav." + ["Back to the dashboard"]} />
                </button>
              </Link>
              <div className="renderValidate">
                {/* {this.renderValidate()} */}
              </div>
            </div>


          </div>




          <div className="scrollTop" onClick={this.scrollTop.bind(this)}>
            <i className="fas fa-arrow-up" style={{ color: "#E30119" }}></i>
          </div>
        </div>
      )
    }
  }
}




const mapStateToProps = state => ({
  eightD: state.eightD.eightD,
  message: state.eightD.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addFieldEightD,removeFieldEightD, fetchEightD, updateFieldEightD, validate
}, dispatch); 

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(FormContainer)));
